<template>
  <div id="berth-view-data">
    <berth-form
      mode="view"
      :itemId="itemId"
      :lastSearchCondition="lastSearchCondition"
    >
    </berth-form>
  </div>
</template>

<script>

import BerthForm from "./BerthForm";

export default {
  components: {
    BerthForm,
  },
  data() {
    return {
      itemId: this.$route.params.itemId,
      lastSearchCondition: this.$route.params.lastSearchCondition
    }
  },
  created() {
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>
